import { BasicTable, BasicTableBody, BasicTableCell, BasicTableCheckbox, BasicTableResponsive, BasicTableHead, BasicTableHeadCell, BasicTableManaged, BasicTableRow, } from '../BasicTable';
/**
 * @deprecated Use BasicTableResponsive instead
 */
export var LegacyTableResponsive = BasicTableResponsive;
/**
 * @deprecated Use BasicTableManaged instead
 */
export var LegacyTableManagedExperimental = BasicTableManaged;
/**
 * @deprecated Use BasicTable instead
 */
export var LegacyTable = BasicTable;
/**
 * @deprecated Use BasicTableBody instead
 */
export var LegacyTableBody = BasicTableBody;
/**
 * @deprecated Use BasicTableCell instead
 */
export var LegacyTableCell = BasicTableCell;
/**
 * @deprecated Use BasicTableCheckbox instead
 */
export var LegacyTableCheckbox = BasicTableCheckbox;
/**
 * @deprecated Use BasicTableHead instead
 */
export var LegacyTableHead = BasicTableHead;
/**
 * @deprecated Use BasicTableHeadCell instead
 */
export var LegacyTableHeadCell = BasicTableHeadCell;
/**
 * @deprecated Use BasicTableRow instead
 */
export var LegacyTableRow = BasicTableRow;
//# sourceMappingURL=index.js.map